<template>
  <div class="coupon-container">
    <template v-if="isDark && discountType == 'normal'">
      <div class="coupon-label-dark">
        <span class="coupon-label-dark-left"></span>
        <div class="coupon-label-dark-item" v-html="textHtml"></div>
        <span class="coupon-label-dark-right"></span>
      </div>
    </template>
    <template v-else>
      <div class="coupon-label" :class="discountType">
        <div class="coupon-top"></div>
        <div class="coupon-middle"></div>
        <div class="coupon-middle-place"></div>
        <div class="coupon-bottom"></div>
        <div class="coupon-text" v-html="textHtml"></div>
        <div class="coupon-text hidden" v-html="textHtml"></div>
      </div>
    </template>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { app } from '@/utils'
export default {
  name: 'CouponLabel',
  props: {
    // 四种颜色 white/red/black/purple  背景主色调
    theme: String,
    text: String
  },
  data() {
    return {
      couponWidth: 150,
      isDark: app.getColorScheme()
    }
  },
  computed: {
    ...mapState('detailv3', ['skuInfo']),
    ...mapGetters('detailv3', ['discountType']),
    textHtml() {
      var reg = /[0-9]+(\.?[0-9]+)?\%?/g
      return this.text.replace(reg, '<strong style="font-weight:bold">$&</strong>')
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.couponWidth = this.$refs.coupon?.offsetWidth || 0
    })
  }
}
</script>
<style lang="scss" scoped>
.coupon-container {
  display: inline-block;
}
.coupon-label {
  display: inline-block;
  position: relative;
  height: 60px;
  overflow: hidden;
  box-sizing: border-box;
  &.vip {
    // 设置背景颜色
    .coupon-top,
    .coupon-middle-place,
    .coupon-bottom {
      background-color: rgba(255, 215, 112, 0.6);
    }
    // 设置border颜色
    .coupon-top,
    .coupon-bottom {
      border: 1px solid rgb(255, 193, 33, 0.5);
    }

    .coupon-top {
      border-bottom: 0;
    }
    .coupon-bottom {
      border-top: 0;
    }

    .coupon-middle::before,
    .coupon-middle::after {
      border: 1px solid rgb(255, 193, 33, 0.8);
      box-shadow: rgba(255, 215, 112, 0.6) 0 0 0 12px;
    }

    .coupon-text {
      color: #000;
    }
  }

  &.normal,
  &.quickbuynoatmos,
  &.quickbuypreheat {
    .coupon-top,
    .coupon-middle-place,
    .coupon-bottom {
      background-color: rgba(255, 67, 52, 0.12);
    }

    .coupon-top,
    .coupon-bottom {
      border: 1px solid #ffb1b4;
    }

    .coupon-top {
      border-bottom: 0;
    }
    .coupon-bottom {
      border-top: 0;
    }

    .coupon-middle::before,
    .coupon-middle::after {
      border: 1px solid #ffb1b4;
      box-shadow: rgba(255, 67, 52, 0.12) 0 0 0 13px;
    }

    .coupon-text {
      color: #f10313;
    }
  }
}

.coupon-top,
.coupon-bottom {
  height: 21px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, 0.2);
}

.coupon-top {
  border-bottom: 0;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.coupon-bottom {
  border-top: 0;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}

.coupon-middle {
  position: relative;
  height: 18px;
  overflow: hidden;
}
.coupon-middle-place {
  position: absolute;
  height: 18px;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  width: calc(100% - 36px);
  margin: 0 18px;
  background-color: rgba(255, 255, 255, 0.2);
}

.coupon-middle::before,
.coupon-middle::after {
  content: '';
  position: absolute;
  width: 15px;
  height: 18px;
  border-radius: 100%;
  top: 50%;
  transform: translateY(-50%);
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: rgba(255, 255, 255, 0.2) 0 0 0 13px;
}

.coupon-middle::before {
  left: -14px;
}

.coupon-middle::after {
  right: -14px;
}

.coupon-text {
  position: absolute;
  top: 0;
  font-size: 30px;
  line-height: 63px;
  padding: 0 18px;
  z-index: 10;
  @include fontColor(#ffffff, rgba(255, 255, 255, 0.9));
}

.hidden {
  position: relative;
  visibility: hidden;
}

// .vivo-dark-mode {
//   .coupon-label {
//     &.vip {
//       .coupon-middle::before,
//       .coupon-middle::after {
//         border: 1px solid rgba(182, 132, 5, 0.8);
//         box-shadow: rgba(59, 54, 43, 0.6) 0 0 0 12px !important;
//       }
//     }
//     &.normal,
//     &.quickbuynoatmos,
//     &.quickbuypreheat {
//       .coupon-middle::before,
//       .coupon-middle::after {
//         box-shadow: rgba(255, 67, 52, 0.12) 0 0 0 13px;
//       }
//     }
//     .coupon-middle::before,
//     .coupon-middle::after {
//       box-shadow: #000 0 0 0 13px;
//     }
//   }
// }
.coupon-label-dark {
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  .coupon-label-dark-left {
    background-image: url('../imgs/dark-coupon-left.png');
    width: 28px;
    height: 60px;
    display: inline-block;
    background-size: cover;
  }
  .coupon-label-dark-right {
    background-image: url('../imgs/dark-coupon-right.png');
    width: 28px;
    height: 60px;
    display: inline-block;
    background-size: cover;
  }
  .coupon-label-dark-item {
    display: inline-block;
    position: relative;
    height: 60px;
    overflow: hidden;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: rgba(241, 3, 19, 0.12);
    font-size: 30px;
    line-height: 63px;
    padding: 0;
    z-index: 10;
    @include fontColor($brand-text, #d90311);
  }
}
</style>
<style lang="scss" scoped>
.vivo-fontscale-1 {
  .coupon-text {
    line-height: 76px;
  }
}
.vivo-fontscale-4 {
  .coupon-text {
    line-height: 58px;
  }
}
.vivo-fontscale-5 {
  .coupon-text {
    line-height: 52px;
  }
}
</style>
